import React, { Component } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Swal from "sweetalert2";
import NeshanMap from "react-neshan-map-leaflet";
import { mapKey } from "../../../settings/config";
import Image from "../../../base/features/micro/Image";
import Lightbox from "react-image-lightbox";

class OrderResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneDetail: false,
      priceBlock: false,
      addressBlock: false,
      providerBlock: false,
    };
  }

  render() {
    return (
      <div className="row mx-0 px-0">
        <div className="col-12 px-4 py-3 fs-6 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col-auto fw px-0 align-self-center">
              <p className="mb-0">تاریخ ثبت سفارش</p>
            </div>
            <div className="col text-start px-0 fs-6 fw align-self-center">
              <p className="mb-0">{this.props.order.created}</p>
            </div>
          </div>
        </div>
        <div className="col-12 px-4 py-3 fs-6 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col-auto fw px-0 align-self-center">
              <p className="mb-0">{this.props.order.status_title}</p>
            </div>
            <div className="col text-start px-0 fs-6 fw align-self-center">
              <p className="mb-0">{this.props.order.status_sub_title}</p>
            </div>
          </div>
        </div>

        <div className="col-12 px-4 py-3 fs-6 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col-auto fw px-0 align-self-center">
              <p className="mb-0">مبلغ کل</p>
            </div>
            <div className="col text-start px-0 fs-6 fw align-self-center">
              <p
                className="mb-0 color-main"
                onClick={() =>
                  this.setState({ priceBlock: !this.state.priceBlock })
                }
              >
                {this.props.order.payable_price.title}
                <span className="me-1 ms-2 fs-7">
                  {this.props.order.discount.currency}
                </span>
                {this.state.priceBlock ? (
                  <FiChevronUp size="20" />
                ) : (
                  <FiChevronDown size="20" />
                )}
              </p>
            </div>
          </div>
          {this.state.priceBlock && (
            <section className="mt-3">
              <div className="row mx-0 px-0 mb-2 text-muted">
                <div className="col-auto px-0 align-self-center">
                  <p className="mb-0 small fw-bold">مبلغ کل اقلام</p>
                </div>
                <div className="col text-start px-0 align-self-center">
                  <p className="mb-0">
                    {this.props.order.price.title}
                    <span className="me-1 fs-7">
                      {this.props.order.price.currency}
                    </span>
                  </p>
                </div>
              </div>
              <div className="row mx-0 px-0 mb-2 text-muted">
                <div className="col-auto px-0 align-self-center">
                  <p className="mb-0 fw-bold small">تخفیف</p>
                </div>
                <div className="col text-start px-0 align-self-center">
                  <p className="mb-0">
                    {this.props.order.discount.title}
                    <span className="me-1 fs-7">
                      {this.props.order.discount.currency}
                    </span>
                  </p>
                </div>
              </div>
              <div className="row mx-0 px-0 mb-2 text-muted">
                <div className="col-auto px-0 align-self-center">
                  <p className="mb-0 fw-bold small">هزینه ارسال</p>
                </div>
                <div className="col text-start px-0 align-self-center">
                  <p className="mb-0 small">
                    {this.props.order.shipping.title}
                    <span className="me-1 fs-7">
                      {this.props.order.shipping.currency}
                    </span>
                  </p>
                </div>
              </div>
              <div className="row mx-0 px-0 text-muted">
                <div className="col-auto px-0 align-self-center">
                  <p className="mb-0 fw-bold small">شیوه پرداخت</p>
                </div>
                <div className="col text-start px-0 align-self-center">
                  <p className="mb-0 small">
                    {this.props.order.payment_type}
                    <img
                      className="me-1"
                      src={
                        require("../../../base/assets/icons/Document.svg")
                          .default
                      }
                      alt="document"
                    />
                  </p>
                </div>
              </div>
              {this.props.order.receipt && (
                <div className="row mx-0 px-0  mb-2 text-muted">
                  <div className="col-auto px-0 align-self-center">
                    <p className="mb-0 fw-bold small">فیش واریز</p>
                  </div>
                  <div className="col text-start px-0 align-self-center">
                    <section
                      onClick={() =>
                        this.setState({
                          selectedImage: this.props.order.receipt,
                          lightbox: true,
                        })
                      }
                    >
                      <Image
                        imageUri={
                          this.props.order.receipt && this.props.order.receipt
                        }
                        imageHeight={"100"}
                        imageWidth={"100"}
                        imgClassName={"img-cover"}
                        extraClassName={"rounded-2 bg-color-main p-3"}
                      />
                    </section>
                  </div>
                </div>
              )}
              {this.props.order.receipt &&
                this.state.lightbox &&
                this.state.selectedImage && (
                  <Lightbox
                    mainSrc={this.state.selectedImage}
                    reactModalStyle={{
                      overlay: {
                        zIndex: "100000000",
                      },
                      content: {
                        zIndex: "100000000",
                      },
                    }}
                    onCloseRequest={() => this.setState({ lightbox: false })}
                  />
                )}
            </section>
          )}
        </div>
        <div className="col-12 px-4 py-3 fs-6 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col-auto fw px-0 align-self-center">
              <p className="mb-0">ارسال به</p>
            </div>
            <div className="col text-start px-0 fw align-self-center">
              <p
                className="mb-0"
                onClick={() =>
                  this.setState({ addressBlock: !this.state.addressBlock })
                }
              >
                {/*<span className="small ms-2">*/}
                {/*  {this.props.order.address.address}*/}
                {/*</span>*/}
                {this.state.addressBlock ? (
                  <FiChevronUp size="20" />
                ) : (
                  <FiChevronDown size="20" />
                )}
              </p>
            </div>
          </div>
          {this.state.addressBlock && (
            <section className="mt-3">
              <div className="row mx-0 px-0 mb-2 text-muted">
                <div className="col-12 px-0 align-self-center">
                  <p className="mb-0 small fw">
                    {this.props.order.address.address}
                  </p>
                </div>
                {this.props.order.address.latitude &&
                  this.props.order.address.longitude && (
                    <div
                      className="col-12 px-0 position-relative mt-3"
                      id="map"
                    >
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href={`https://maps.google.com/?q=${this.props.order.address.latitude},${this.props.order.address.longitude}`}
                      >
                        <NeshanMap
                          style={{
                            height: "170px",
                            top: "0",
                            left: "0",
                            width: "100%",
                            borderRadius: "14px",
                          }}
                          options={{
                            key: mapKey,
                            center: [
                              this.props.order.address.latitude,
                              this.props.order.address.longitude,
                            ],
                            zoom: 13,
                            maptype: "dreamy-gold",
                            poi: true,
                          }}
                          onInit={(L, myMap) => {
                            L.marker([
                              this.props.order.address.latitude,
                              this.props.order.address.longitude,
                            ]).addTo(myMap);
                          }}
                        />
                      </a>
                    </div>
                  )}
              </div>
            </section>
          )}
        </div>
        {this.props.order.shipping_provider && (
          <div className="col-12 px-4 py-3 fs-6 border-bottom">
            <div className="row mx-0 px-0">
              <div className="col-auto fw-bold px-0 align-self-center">
                <p className="mb-0">شیوه ارسال</p>
              </div>
              <div className="col text-start px-0 fw-bolder align-self-center">
                <p
                  className="mb-0"
                  onClick={() =>
                    this.setState({ providerBlock: !this.state.providerBlock })
                  }
                >
                  <span className="small ms-2">
                    {this.props.order.shipping_provider.title}
                  </span>
                  {this.state.providerBlock ? (
                    <FiChevronUp size="20" />
                  ) : (
                    <FiChevronDown size="20" />
                  )}
                </p>
              </div>
            </div>
            {this.state.providerBlock && (
              <section className="mt-3">
                {this.props.order.shipping_tracking_code && (
                  <div className="row mx-0 px-0 mb-2 text-muted">
                    <div className="col-auto px-0 align-self-center">
                      <p className="mb-0 small fw-bold">کد رهگیری</p>
                    </div>
                    <div className="col text-start px-0 align-self-center">
                      <CopyToClipboard
                        text={this.props.order.shipping_tracking_code}
                        onCopy={() => {
                          Swal.fire({
                            text: "کپی شد",
                            showConfirmButton: false,
                            toast: true,
                            customClass: {
                              htmlContainer: "text-center m-0 w-auto",
                            },
                            width: 100,
                            timer: 1500,
                            timerProgressBar: true,
                          });
                        }}
                      >
                        <p className="mb-0">
                          {this.props.order.shipping_tracking_code}
                        </p>
                      </CopyToClipboard>
                    </div>
                  </div>
                )}
                {this.props.order.shipping_provider.shipping_config &&
                  (this.props.order.shipping_link ||
                    this.props.order.shipping_provider.shipping_config
                      .tracking_link) && (
                    <div className="row mx-0 px-0 mb-2">
                      <div className="col-auto px-0 align-self-center">
                        <p className="mb-0 fw-bold small text-muted">
                          لینک سفر / پیگیری
                        </p>
                      </div>
                      <div className="col text-start px-0 align-self-center">
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={
                            this.props.order.shipping_link ||
                            this.props.order.shipping_provider.shipping_config
                              .tracking_link
                          }
                        >
                          <p className="mb-0 text-muted" dir="ltr">
                            {this.props.order.shipping_link ||
                              this.props.order.shipping_provider.shipping_config
                                .tracking_link}
                          </p>
                        </a>
                      </div>
                    </div>
                  )}
                <div className="row mx-0 px-0 text-muted">
                  <div className="col-auto px-0 align-self-center">
                    <p className="mb-0 fw-bold small">هزینه ارسال</p>
                  </div>
                  <div className="col text-start px-0 align-self-center">
                    <p className="mb-0 small">
                      {this.props.order.shipping.title}
                      <span className="me-1 fs-7">
                        {this.props.order.shipping.currency}
                      </span>
                    </p>
                  </div>
                </div>
              </section>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default OrderResult;
